// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-desktop {
    width: 97%;
    height: 100%;
    padding: 15px;
    margin: 0 auto 30px 0;
    background-color: #0e0f15;
    color: white;
    border: 2px solid #f09502;
    /* 🚀 PERFORMANCE - Hardware acceleration */
    will-change: width, transform;
    /* 🎨 SMOOTH ANIMATIONS */
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
}

/* 🎛️ BOTÓN OCULTAR MENÚ - Debajo del menú */
.hide-menu-container {
    padding: 10px 15px;
    border-top: 1px solid rgba(240, 149, 2, 0.2);
    text-align: center;
}

.hide-menu-btn {
    background: transparent !important;
    border: none !important;
    color: #f09502 !important;
    padding: 8px 15px !important;
    border-radius: 6px !important;
    transition: all 0.2s ease;
    font-size: 0.9rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.hide-menu-btn:hover {
    background-color: rgba(240, 149, 2, 0.1) !important;
    color: #f09502 !important;
}

.hide-menu-btn:focus {
    outline: 2px solid #f09502 !important;
    outline-offset: 2px;
}

/* 🎛️ BOTÓN FLOTANTE - Cuando menú está oculto */
.floating-menu-btn {
    position: fixed;
    top: 20px;
    left: 20px;
    width: 50px;
    height: 50px;
    background-color: #f09502;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1000;
    box-shadow: 0 4px 12px rgba(240, 149, 2, 0.3);
    transition: all 0.3s ease;
}

.floating-menu-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(240, 149, 2, 0.4);
}

.floating-menu-btn i {
    font-size: 1.5rem;
}

.menu-desktop .menu-desktop-1 div img {
    width: 100%;
    padding: 15px;
}

.menu-desktop div p {
    margin-left: 15px;
}

.menu-desktop div p:last-child {
    margin-bottom: 7px;
}

.menu-desktop div p:hover {
    cursor: pointer;
    color: #f09502a8;
}
.menu-desktop-1 i {
    display: inline-block;
    margin-right: 8px;
}

.activo {
    color: #f09502;
}

.noticia {
    width: 97% !important;
    margin: 0 auto 0 0;
    overflow-x: hidden;
    margin-bottom: 38px;
    border: 2px solid #f09502;
}

.rrss {
    width: 97%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.rrss a {
    width: 15%;
    margin: 0 2%;
}

.rrss img {
    max-width: 100%;
    height: auto;
}

.chevron-icon {
    transition: transform 0.3s ease !important;
}

.chevron-icon.rotate {
    transform: rotate(180deg) !important;
}

.padding-p-collapse {
    margin-bottom: 4px !important;
}

  p.no-hover:hover {
    /* Restablece los estilos de hover */
    color: inherit; /* Restablece el color original */
    /* Añade otros estilos necesarios para restablecer */
}

.padding-p-collapse a{
    color: white;
    text-decoration: none;
}

/* Override global card-body padding for menu submenus */
.menu-desktop .card-body {
    padding: 0 !important;
    padding-left: 1.1vw !important; /* Restore left margin for submenus */
}

.menu-desktop .sub-option {
    padding: 0 !important;
    padding-left: 1.1vw !important; /* Restore left margin for submenus */
}


@keyframes fade {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  
  .loading-text {
    animation: fade 1.25s infinite;
  }

.add-funds{
    padding: 0 !important;
    width: 45px !important;
    cursor: pointer;
}

.balance-text{
    font-size: 1.75rem !important;
}

.loading-text{
    font-size: 1.75rem !important;
}

/* Media queries for responsiveness */
@media (max-width: 1366px) {
    .add-funds {
        width: 30px !important;
    }
    .balance-text, .loading-text {
        font-size: 1.2rem !important;
    }
}

@media (max-width: 1200px) {
    .add-funds {
        width: 25px !important;
    }
    .balance-text, .loading-text {
        font-size: 1rem !important;
    }
}

@media (max-width: 992px) {
    .add-funds {
        width: 20px !important;
    }
    .balance-text, .loading-text {
        font-size: 0.875rem !important;
    }
}

@media (max-width: 768px) {
    .add-funds {
        width: 15px !important;
    }
    .balance-text, .loading-text {
        font-size: 0.75rem !important;
    }
}

@media (max-width: 576px) {
    .add-funds {
        width: 10px !important;
    }
    .balance-text, .loading-text {
        font-size: 0.625rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-desktop/menu-desktop.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;IACzB,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;EAEE;IACE,oCAAoC;IACpC,cAAc,EAAE,iCAAiC;IACjD,oDAAoD;AACxD;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA,wDAAwD;AACxD;IACI,qBAAqB;IACrB,8BAA8B,EAAE,qCAAqC;AACzE;;AAEA;IACI,qBAAqB;IACrB,8BAA8B,EAAE,qCAAqC;AACzE;;;AAGA;IACI;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,8BAA8B;EAChC;;AAEF;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,qCAAqC;AACrC;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".menu-desktop {\n    width: 97%;\n    height: 100%;\n    padding: 15px;\n    margin: 0 auto 30px 0;\n    background-color: #0e0f15;\n    color: white;\n    border: 2px solid #f09502;\n    /* 🚀 PERFORMANCE - Hardware acceleration */\n    will-change: width, transform;\n    /* 🎨 SMOOTH ANIMATIONS */\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow: hidden;\n}\n\n/* 🎛️ BOTÓN OCULTAR MENÚ - Debajo del menú */\n.hide-menu-container {\n    padding: 10px 15px;\n    border-top: 1px solid rgba(240, 149, 2, 0.2);\n    text-align: center;\n}\n\n.hide-menu-btn {\n    background: transparent !important;\n    border: none !important;\n    color: #f09502 !important;\n    padding: 8px 15px !important;\n    border-radius: 6px !important;\n    transition: all 0.2s ease;\n    font-size: 0.9rem;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.hide-menu-btn:hover {\n    background-color: rgba(240, 149, 2, 0.1) !important;\n    color: #f09502 !important;\n}\n\n.hide-menu-btn:focus {\n    outline: 2px solid #f09502 !important;\n    outline-offset: 2px;\n}\n\n/* 🎛️ BOTÓN FLOTANTE - Cuando menú está oculto */\n.floating-menu-btn {\n    position: fixed;\n    top: 20px;\n    left: 20px;\n    width: 50px;\n    height: 50px;\n    background-color: #f09502;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 1000;\n    box-shadow: 0 4px 12px rgba(240, 149, 2, 0.3);\n    transition: all 0.3s ease;\n}\n\n.floating-menu-btn:hover {\n    transform: scale(1.1);\n    box-shadow: 0 6px 20px rgba(240, 149, 2, 0.4);\n}\n\n.floating-menu-btn i {\n    font-size: 1.5rem;\n}\n\n.menu-desktop .menu-desktop-1 div img {\n    width: 100%;\n    padding: 15px;\n}\n\n.menu-desktop div p {\n    margin-left: 15px;\n}\n\n.menu-desktop div p:last-child {\n    margin-bottom: 7px;\n}\n\n.menu-desktop div p:hover {\n    cursor: pointer;\n    color: #f09502a8;\n}\n.menu-desktop-1 i {\n    display: inline-block;\n    margin-right: 8px;\n}\n\n.activo {\n    color: #f09502;\n}\n\n.noticia {\n    width: 97% !important;\n    margin: 0 auto 0 0;\n    overflow-x: hidden;\n    margin-bottom: 38px;\n    border: 2px solid #f09502;\n}\n\n.rrss {\n    width: 97%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n}\n\n.rrss a {\n    width: 15%;\n    margin: 0 2%;\n}\n\n.rrss img {\n    max-width: 100%;\n    height: auto;\n}\n\n.chevron-icon {\n    transition: transform 0.3s ease !important;\n}\n\n.chevron-icon.rotate {\n    transform: rotate(180deg) !important;\n}\n\n.padding-p-collapse {\n    margin-bottom: 4px !important;\n}\n\n  p.no-hover:hover {\n    /* Restablece los estilos de hover */\n    color: inherit; /* Restablece el color original */\n    /* Añade otros estilos necesarios para restablecer */\n}\n\n.padding-p-collapse a{\n    color: white;\n    text-decoration: none;\n}\n\n/* Override global card-body padding for menu submenus */\n.menu-desktop .card-body {\n    padding: 0 !important;\n    padding-left: 1.1vw !important; /* Restore left margin for submenus */\n}\n\n.menu-desktop .sub-option {\n    padding: 0 !important;\n    padding-left: 1.1vw !important; /* Restore left margin for submenus */\n}\n\n\n@keyframes fade {\n    0% {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  \n  .loading-text {\n    animation: fade 1.25s infinite;\n  }\n\n.add-funds{\n    padding: 0 !important;\n    width: 45px !important;\n    cursor: pointer;\n}\n\n.balance-text{\n    font-size: 1.75rem !important;\n}\n\n.loading-text{\n    font-size: 1.75rem !important;\n}\n\n/* Media queries for responsiveness */\n@media (max-width: 1366px) {\n    .add-funds {\n        width: 30px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 1.2rem !important;\n    }\n}\n\n@media (max-width: 1200px) {\n    .add-funds {\n        width: 25px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 1rem !important;\n    }\n}\n\n@media (max-width: 992px) {\n    .add-funds {\n        width: 20px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 0.875rem !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .add-funds {\n        width: 15px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 0.75rem !important;\n    }\n}\n\n@media (max-width: 576px) {\n    .add-funds {\n        width: 10px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 0.625rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
